// import { Link } from '@mui/material';
import Link from 'next/link';
import { getEditorColor, renderColor } from '../../util/ColorUtil';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';
import { useRouter } from 'next/router';
import {
  correctInternalLink,
  getEditorColors,
  isItUndefined,
  isLinkAbsolute,
  modifyLinks,
} from '../../util/DataUtil';
import { cleanHTML } from '../utils/htmlUtils';
import CtaBarButton from '../base/cta-bar-button';
import { useEffect, useRef, useState } from 'react';
import WaveEffect from './WaveEffect';

const TemplateProduct = (props) => {
  const dataSet = Object.assign(
    {},
    props?.facilityData,
    props?.metroData,
    props?.locationData,
    props?.regionData
  );
  const productCount =
    props?.children?.field_product?.product_paragraph_type.length;
  const [marketoTrigger, setMarketoTrigger] = useState(false);
  const router = useRouter();
  const { asPath, locale } = router;
  const emphasizedTextColor = getEditorColors(
    isItUndefined(props?.children?.field_formatted_title),
    isItUndefined(props?.children?.field_sub_title),
    isItUndefined(props?.children?.field_description)
  ).filter((x) => x)[0];

  const handleProductClick = (item) => {
    if (isLinkAbsolute(item?.field_link[0]?.uri)) {
      window.open(item?.field_link[0]?.uri, '_blank');
    } else {
      router.push(correctInternalLink(item?.field_link[0]?.uri));
    }
  };

  //function for making product card to be right clickable

  // const handleContextMenu = (e, item) => {
  //     e.preventDefault();
  //     const internalLink = correctInternalLink(item?.field_link[0]?.uri);
  //     const absoluteUrl = window.location.origin + internalLink;
  //     window.open(absoluteUrl, '_blank');
  // };

  function getFirstWord(text) {
    if (!text || typeof text !== 'string') return '';

    // Trim whitespace and split into words
    const words = text.trim().split(/\s+/);

    // Return first word or empty string
    return words[0] || '';
  }

  const renderProducts = (data) => {
    if (!data) return;
    const [hoveredItem, setHoveredItem] = useState(null);

    return data.map((item, key) => (
      <div
        className={`div-product-link product ${getEditorColor(props?.children?.field_formatted_title[0]?.value)}`}
        key={`product-index-${item?.id || item?.name || item?.title || 'product'}`}
        onClick={() => handleProductClick(item)}
        // onContextMenu={(e) => handleContextMenu(e, item)}
        onMouseEnter={() => setHoveredItem(item.id)}
        onMouseLeave={() => setHoveredItem(null)}
      >
        {(asPath == '/' || asPath?.includes('home-global-v2')) &&
        hoveredItem === item.id ? (
          <WaveEffect></WaveEffect>
        ) : null}
        <span className="product-title">{item?.field_title[0]?.value}</span>
        <span className="product-description">
          {cleanHTML(item?.field_description_long[0]?.value)}
        </span>
        <Link
          href={correctInternalLink(item?.field_link[0]?.uri)}
          // legacybehavior="true"
          passHref
        >
          <a
            className={'a-product-link'}
            target={
              isLinkAbsolute(item?.field_link[0]?.uri) ? '_blank' : '_self'
            }
          >
            {asPath == '/' || asPath?.includes('home-global-v2') ? (
              <span
                className="product-link"
                data-full-text={item?.field_link[0]?.title}
                data-first-word={getFirstWord(item?.field_link[0]?.title)}
              />
            ) : (
              <span className="product-link">{item?.field_link[0]?.title}</span>
            )}
          </a>
        </Link>
      </div>
    ));
  };

  return (
    <div
      className={`template-product ${renderColor(props?.children?.field_text_color[0]?.value, props?.regionColor)}`}
    >
      <div className="inner-container">
        <div className="product-wrapper">
          <span
            dangerouslySetInnerHTML={{
              __html: cleanHTML(
                modifyLinks(
                  isItUndefined(props?.children?.field_formatted_title),
                  locale
                )
              ),
            }}
            className={`product-title ${emphasizedTextColor ? emphasizedTextColor : ''}`}
          ></span>
          <span
            dangerouslySetInnerHTML={{
              __html: cleanHTML(
                modifyLinks(
                  getObjectValueByMachineName(
                    props?.children?.field_sub_title[0]?.value,
                    dataSet
                  ),
                  locale
                )
              ),
            }}
            className={`product-subtitle ${emphasizedTextColor ? emphasizedTextColor : ''}`}
          ></span>
        </div>
        <span
          dangerouslySetInnerHTML={{
            __html: cleanHTML(
              modifyLinks(
                getObjectValueByMachineName(
                  props?.children?.field_description[0]?.value,
                  dataSet
                ),
                locale
              )
            ),
          }}
          className={`product-description ${emphasizedTextColor ? emphasizedTextColor : ''}`}
        ></span>
        {props?.children?.field_cta_bar_button_selection?.length > 0 ? (
          <CtaBarButton
            blockTypeClass={'template-product'}
            setMarketoTrigger={setMarketoTrigger}
            data={
              props?.children?.field_cta_bar_button_selection[0]?.cta_bar_button
            }
            pathname={true}
          />
        ) : (
          <></>
        )}
        <div className={'products'}>
          {renderProducts(
            props?.children?.field_product?.product_paragraph_type
          )}
        </div>
      </div>
    </div>
  );
};

export default TemplateProduct;
